import {
  fontSmall,
  inputHoverColors
} from '../../../views/action-flow/components/library/css'
import styled, {css} from 'styled-components'

// WIP here

export const Textarea = styled.textarea<{valid: boolean}>`
  height: 160px;
  min-height: 30px;
  border: none;
  font-family: 'atomic___RobotoMono', monospace;
  color: ${p => (p.valid ? p.theme.black : p.theme.red)};
  display: block;
  background: none;
  resize: vertical;
  padding: 12px;
  overflow: auto;
  white-space: pre;
  ${fontSmall}
  &:read-only {
    background-color: white;
  }
`

export const Label = styled.label`
  color: ${props => props.theme.colors.grey11};
  display: flex;
  align-items: center;
  height: 30px;
  padding: 8px 12px;
  background-color: transparent;
  ${fontSmall}
`

export const Wrapper = styled.div<{hasLabel: boolean; readOnly?: boolean}>`
  display: block;
  border-radius: 4px;
  position: relative;
  ${props =>
    props.hasLabel &&
    css`
      textarea {
        padding-top: 5px;
      }
    `}
  ${props =>
    props.readOnly
      ? css`
          border: solid 1px ${p => p.theme.colors.grey8};
          background-color: white;
        `
      : inputHoverColors}
`
// useful in css rules
export const JSONFieldWrapper = Wrapper
